import React from 'react';

export default function OutlinedCheckMark({ stroke = '#323232', ...rest }: React.SVGProps<SVGSVGElement>) {
    return (
        <svg width="800px" height="800px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...rest}>
            <circle cx="12" cy="12" r="10" stroke={stroke} strokeWidth="1.5" />
            <path
                d="M8.5 12.5L10.5 14.5L15.5 9.5"
                stroke={stroke}
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
}
